export default __webpack_public_path__ + "static/media/022-distribution-2.43695baf.png";